module.exports = __webpack_public_path__ + "static/media/Lead Follow Up@4x.807a8a96.png";